import { render, staticRenderFns } from "./LeagueStandings.vue?vue&type=template&id=0589adb7&scoped=true&"
import script from "./LeagueStandings.vue?vue&type=script&lang=js&"
export * from "./LeagueStandings.vue?vue&type=script&lang=js&"
import style0 from "./LeagueStandings.vue?vue&type=style&index=0&id=0589adb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0589adb7",
  null
  
)

export default component.exports